<!-- Information Modal -->
<div class="modal-header">
    <app-button (click)="printText()" [buttonClasses]="'modal-button-padding'" *ngIf="printURL"
        >Print</app-button
    >
    <button
        (click)="modalRef.dismiss('Cross click')"
        aria-label="Close"
        class="close"
        data-dismiss="modal"
        type="button"
    >
        <i class="pbslm-close-thin-cross close-img"></i>
    </button>
</div>
<div class="modal-body">
    <div class="text-fragment">
        <h4 class="fragment-title">{{ role || "" }}</h4>
        <div [innerHtml]="text | bypassSecurity: 'html'"></div>
    </div>
</div>
